export { default } from "./QuizIcon";
